export const ACTIVATE_CARD = '/api/v1/Public/VipCard/Activate'
export const SUPERCLIENT_INFO = '/api/v1/Public/Superclient'
export const LOG_ERROR = '/api/v1/Public/Portal/LogError'
export const LOG_REQUST_ERROR = '/api/v1/Public/Portal/LogRequestError'